import httpClient from "../http/http-client";
import { ICategory, ICategoryDetail, IFactorSearchResponse } from './category.model';

export default class CategoryService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAllCategories(queryString?: string): Promise<ICategory[]> {
    return this.http.get(`category${queryString ? queryString : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getAllCategoriesByGroupId(groupId: string): Promise<ICategory[]> {
    return this.http.get(`category/by-group?groupId=${groupId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getOneCategory(id: string, queryString?: string): Promise<ICategoryDetail> {
    return this.http.get(`category/${id}${queryString ? queryString : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getOneCategoryFilter(id: string, queryString?: string): Promise<ICategoryDetail> {
    return this.http.get(`category/${id}/filter${queryString ? queryString : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }

  /** Flattened factor search: same filters as the cascade, whole conversions in one list. */
  async searchCategoryFactors(id: string, queryString: string): Promise<IFactorSearchResponse> {
    return this.http.get(`category/${id}/factor-search${queryString}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }
}